// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"91":"2be1082a","138":"9d24e4bc","234":"00475c2e","382":"c04a24ba","393":"71506fd4","737":"b52b92fd","787":"ec27dfbb","842":"2cd0ec60"}[chunkId] + ".chunk.js";
};